import React from 'react';

const CreateAccount = () => {
    return (
        <div>
            <h1>Create Account</h1>
        </div>
    );
};

export default CreateAccount;